import { useEffect, useState } from "react";
import { useMediaQuery } from "@mui/material";
import {
  PUBLIC_fetchLocationLevel1,
  PUBLIC_fetchRegions,
} from "../../lib/fetchers";
import {
  buildRedirectTranslatedUrl,
  transformGreekToEnglish,
} from "../../lib/helperFuncs";
import HttpService from "../../services/HttpService";
import ImageCards from "../Cards/ImageCards";
import { ImageItem } from "../Cards/Types";
import Search from "../Search";
import i18n from "../../i18n";
import { useTranslation } from "react-i18next";

function RandomImageList() {
  const [regions, setRegions] = useState<ImageItem[]>([]);
  const [regionsParametrics, setRegionsParametrics] = useState<any[]>([]);
  const [lvl1Options, setLvl1Options] = useState<any[]>([]);
  const { t } = useTranslation();
  const matchesXSbreakpoint = useMediaQuery("(max-width:768px)");

  const setLanguage = (lang: string) => {
    console.info(`Language changed to ${lang}`);

    i18n.changeLanguage(lang === "en-US"
      ? "en"
      : "el");
  };
  useEffect(() => {
    // Get the initial language and set it
    const initialLang = document
      ?.getElementsByTagName("html")?.[0]
      ?.getAttribute("lang");
    if (initialLang) {
      setLanguage("initialLang");
    }

    // Create a new MutationObserver instance
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const observer = new MutationObserver((mutationsList, observer) => {
      // Iterate through each mutation in the list
      for (const mutation of mutationsList) {
        // Check if the mutation is a change to the lang attribute on the html element
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "lang"
        ) {
          // Get the new value of the lang attribute
          const mutationTarget = mutation.target as HTMLElement;
          const newLang = mutationTarget.getAttribute("lang") || "";
          setLanguage(newLang);
        }
      }
    });

    // Observe changes to the html element's attributes
    observer.observe(document.getElementsByTagName("html")[0], {
      attributes: true,
    });

    // Cleanup function to disconnect the observer when the component unmounts
    return () => observer.disconnect();
  }, []);
  const fetchData = async () => {
    try {
      const [regions, lvl1Options, resp] = await Promise.all([
        PUBLIC_fetchRegions(),
        PUBLIC_fetchLocationLevel1(),
        HttpService.getAxiosClient().get(
          `${process.env.REACT_APP_BACKEND_URL}/locations/random?limit=8`
        ),
      ]);
      setRegionsParametrics(regions);
      setLvl1Options(lvl1Options);
      const results: ImageItem[] = resp.data.data.map((x: any) => {
        return {
          id: x["o:id"],
          title:
            i18n.language === "en"
              ? transformGreekToEnglish(`${x["o:title"]}`)
              : x["o:title"],
          img: x.thumbnail_display_urls.large,
          subtitle: t(x?.["locations:region"]?.[0]?.["@value"]),
          displayFavorite: false,
          alwayShowBanner: matchesXSbreakpoint
            ? true
            : false,
          redirect: `${buildRedirectTranslatedUrl()}/location/details/${
            x["o:id"]
          }`,
          redirectOutsideApp: true,
        };
      });

      setRegions(results);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  return (
    <>
      <Search
        regionsParametrics={regionsParametrics}
        lvl1Options={lvl1Options}
      />
      <ImageCards imageData={regions} />
    </>
  );
}

export default RandomImageList;
